import type { BatchJobKindView } from "../../batch_job_kind_contract";
import { CoverageGapRecheckPanel } from "./CoverageGapRecheckPanel";

export const COVERAGE_GAP_RECHECK_VIEW: BatchJobKindView = {
  label: "Coverage gap recheck",
  Panel: CoverageGapRecheckPanel,
  startedFrom: "closing a coverage gap as filled",
};
